<template>
    <div>
        <div class="loading" v-if="loading">
            <van-loading size="0.64rem" color="var(--grey)" />
        </div>
        <div class="container">
            <van-row class="basict-info">
                <van-col span="24">
                    <label>就诊卡号：</label>
                    <div style="display: inline-block;">{{cardNo}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="24">
                    <label>主要诊断：</label>
                    <div style="display: inline-block;">{{diag}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="12">
                    <label>患者姓名：</label>
                    <div style="display: inline-block;">{{formObjcet.name}}</div>
                </van-col>
                <van-col span="12">
                    <label>性别：</label>
                    <div style="display: inline-block;">{{formObjcet.gender == 1?'男':'女'}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="24">
                    <label>证件类别：</label>
                    <div style="display: inline-block;">{{formObjcet.idCategoryName?'':'居民身份证'}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="24">
                    <label>证件号码：</label>
                    <div style="display: inline-block;">{{formObjcet.idCard}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="12">
                    <label>出生日期：</label>
                    <div style="display: inline-block;">{{formObjcet.birthDate}}</div>
                </van-col>
                <van-col span="12">
                    <label>民族：</label>
                    <div style="display: inline-block;">{{formObjcet.nationName?'':'汉'}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="12">
                    <label>联系电话：</label>
                    <div style="display: inline-block;">{{formObjcet.phone}}</div>
                </van-col>
                <van-col span="12">
                    <label>职业类别：</label>
                    <div style="display: inline-block;">{{formObjcet.occupationName?'':'其他'}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="12">
                    <label>婚姻状况：</label>
                    <div style="display: inline-block;">{{formObjcet.maritalName}}</div>
                </van-col>
                <van-col span="12">
                    <label>家庭关系：</label>
                    <div style="display: inline-block;">{{formObjcet.relation.name}}</div>
                </van-col>
            </van-row>
            <van-row class="basict-info">
                <van-col span="24">
                    <label>详细地址：</label>
                    <div style="display: inline-block;">{{formObjcet.address}}</div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            loading: false,
            cardNo: '21051002',
            diag:'慢性胃炎',
            renderData: {},
            formObjcet: {
                id: null,
                name: '',
                idCard: '',
                gender: '',
                birthDate: '',
                phone: '',
                height: '',
                weight: '',
                bloodType: '',
                pastHistory: '',
                allergyHistory: '',
                familyHistory: '',
                personalHabits: '',
                isDefault: false,
                relation: {},
            },
        };
    },
    created() {
        const { $hdk, dicts, renderData, initEdit, id } = this;
        $hdk.renderData({
            keys: ['gender', 'relation'],
            data: this.renderData,
            done() {
                if (id) {
                    initEdit(renderData);
                }
            }
        });
    },
    methods: {
        initEdit(renderData) {
            this.loading = true;
            manageApi.getHealthRecord(this.id).then(res => {
                this.formObjcet = res.data;
                this.formObjcet.relation = _.find(renderData.relation, { 'id': res.data.relation });
                this.chDefault = this.formObjcet.isDefault;
            }).catch(() => {
        
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    props: {
        id: {
            type: String,
            required: false
        }
    }
}
</script>


<style lang="less" scoped>
.loading {
    text-align: center;
}
.container {
    font-size: 0.373333rem;
    background-color: white;
    height: auto;
    padding: 0.4rem;
}

.container label {
    color: #646566;
    width: 80px;
    display: inline-block;
    text-align: right;
}

.container .basict-info {
    line-height: 35px;
     border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
}
</style>